var _circle, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPassword(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 12.5,
    r: 12.5,
    fill: "#C1C5D6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.2234 13.825C14.0518 14.0092 13.8448 14.157 13.6148 14.2595C13.3848 14.3619 13.1365 14.4171 12.8847 14.4215C12.633 14.4259 12.3829 14.3796 12.1494 14.2853C11.916 14.191 11.7039 14.0507 11.5258 13.8726C11.3478 13.6946 11.2074 13.4825 11.1131 13.249C11.0188 13.0155 10.9725 12.7655 10.977 12.5137C10.9814 12.262 11.0365 12.0137 11.139 11.7837C11.2415 11.5537 11.3892 11.3467 11.5734 11.175M16.6109 16.2125C15.5426 17.0269 14.2416 17.4781 12.8984 17.5C8.52344 17.5 6.02344 12.5 6.02344 12.5C6.80087 11.0512 7.87915 9.7854 9.18594 8.78752L16.6109 16.2125ZM11.5859 7.65002C12.0161 7.54932 12.4566 7.49898 12.8984 7.50002C17.2734 7.50002 19.7734 12.5 19.7734 12.5C19.394 13.2098 18.9416 13.878 18.4234 14.4938L11.5859 7.65002Z",
    stroke: "#F2F4F8",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.02344 5.625L19.7734 19.375",
    stroke: "#F2F4F8",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPassword);
export default __webpack_public_path__ + "static/media/password.f25ba2d9b43238b821961fce752f9219.svg";
export { ForwardRef as ReactComponent };